"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FlexColItem = function FlexColItem(_ref) {
  var cols = _ref.cols,
      props = _objectWithoutPropertiesLoose(_ref, ["cols"]);

  var baseColumns = [4, 8, 12];

  if (typeof cols === 'number') {
    cols = new Array(baseColumns.length).fill(cols);
  } else if (typeof cols === 'object') {
    if (cols.length > baseColumns.length) {
      baseColumns = [].concat(baseColumns, new Array(cols.length - baseColumns.length)).fill(baseColumns[baseColumns.length - 1], baseColumns.length - 1);
    } else {
      cols = [].concat(cols, new Array(baseColumns.length - cols.length)).fill(cols[cols.length - 1], cols.length - 1);
    }
  }

  var colWidthsArray = baseColumns.map(function (baseCol, index) {
    var percentage = cols[index] / baseCol;
    return (percentage > 1 ? 100 : percentage * 100) + "%";
  });
  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      width: colWidthsArray,
      flexDirection: 'column'
    }
  }));
};

FlexColItem.propTypes = {
  cols: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)])
};
FlexColItem.defaultProps = {
  cols: 12
};
var _default = FlexColItem;
exports["default"] = _default;